import React, { useEffect, useState } from 'react'
import { Box, Paper, Tabs, Typography, useTheme, Tab, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import ExamEnrollment from './ExamEnrollment';
import ReExamination from './ReExamination';
import Revaluation from './Revaluation';
import TransactionHistory from './TransactionHistory';
import Header from '../../components/navigation/Header';
import ExamBanner from './ExamBanner';
import Schedule from './Schedule';
import Requests from './Requests';
import { bundleExamConnection } from '../../utils/apiService';





// Custom TabPanel
interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  index: string;
}
const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
};

const useStyles = makeStyles<Theme, { isMobile: boolean }>(() => ({
  header: {
    fontSize: '18px',
    fontWeight: '500',
  },
  container: ({ isMobile }) => ({
    borderRadius: isMobile ? '0px' : '8px',
    background: '#ffffff',
    marginTop: isMobile ? '0px' : '20px',
    position: 'relative',
    overflow: 'auto',
    height: isMobile ? '100vh' : 'calc(100vh - 155px)',
    padding: '12px !important',
  }),
  tabRoot: {
    textTransform: 'capitalize',
    fontSize: '16px !important',
    fontWeight: 500,
  },
}));

const MyExam = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const classes = useStyles({ isMobile });
  const [value, setValue] = useState('one');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box>

      <Header title="Exams" />
      <div className='mt-4'>
        {/* <ExamBanner /> */}
      </div>

      <Box className={classes.container}>
        <Box sx={{ padding: isMobile ? '12px 0px' : '12px' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant={isMobile ? 'fullWidth' : 'standard'}
            textColor="secondary"
            aria-label="exam tabs"
            sx={{ width: '100%', borderBottom: '1px solid #80808057' }}
          >
            <Tab sx={{ textTransform: 'capitalize' }} classes={{ root: classes.tabRoot }} value="one" label="Schedule" />
            <Tab sx={{ textTransform: 'capitalize' }} classes={{ root: classes.tabRoot }} value="two" label="Requests" />
          </Tabs>
          <TabPanel value={value} index="one">
            <Schedule />
          </TabPanel>
          <TabPanel value={value} index="two">
            <Requests />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};

export default MyExam;
